













































































































import { Component, Watch, Mixins, Inject } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { required } from 'vuelidate/lib/validators';
import { mapItems } from '@/tools/mapitems';
import { validationMixin } from 'vuelidate';
import { progressStore } from '../ProgressStore';
import { File as InputFile, Datepicker } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { IsProgressFormOpenMixin } from '@/pages/profile/mixins';
import ProgressMixin from '../mixin';
import { Heading } from '../components';
import store from '@/pages/profile/store';
import { nokoService } from '@/services';
import { IAddResult, FileFieldEnum, MaxFileEnum, MentorsMapped } from './types';

@Component({
  components: {
    Heading,
    InputFile,
    Datepicker,
    Button,
  },
  validations: {
    progressForm: {
      confirmation_file: { name: { required } },
      student_id: { required },
      municipality: { required },
      competition_id: { required },
      date_finish: { required },
      result: { required },
    },
  },
})
export default class AddResult
  extends Mixins(ProgressMixin, IsProgressFormOpenMixin)
  implements IAddResult
{
  @Inject() $api: ApiInstance;

  progressForm: any = {};
  fileWarnings: string = '';
  mentorFilterValue: string = '';
  mentorFilterText: string = 'Введите как минимум 3 символа';
  mentors: MentorsMapped = [];

  get id(): string {
    return store.state.id;
  }

  get municipalities() {
    const { municipalities } = this.state;
    return mapItems(municipalities);
  }

  get organizators() {
    const { organizators } = this.state;
    const { municipality } = this.progressForm;
    const filteredList = organizators.filter(
      ({ municipality_id }: any) =>
        parseInt(municipality_id, 10) === municipality,
    );
    return !!municipality ? mapItems(filteredList) : mapItems(organizators);
  }

  get eventTypes() {
    const { eventTypes } = this.state;
    return eventTypes.length > 0
      ? mapItems(eventTypes)
      : [{ text: 'Нет программ' }];
  }

  get competitionList() {
    const { nokoCompetitionList } = this.state;
    return nokoCompetitionList;
  }

  get progressResult() {
    const { nokoProgressResult } = this.state;
    return mapItems(nokoProgressResult);
  }

  get competition() {
    const { competitionList } = this;
    const { level } = this.progressForm;
    const filteredList = competitionList.filter(
      (items: any) => items.level === level,
    );
    return !!level ? mapItems(filteredList) : mapItems(competitionList);
  }

  get isDisabled(): boolean {
    const { $v } = this;
    return $v ? $v.$invalid : true;
  }

  @Watch('progressForm.municipality')
  onMunicipalityChange(value: string) {
    if (value) {
      this.progressForm.partner_id = null;
      this.progressForm.event_id = null;
    }
  }

  @Watch('progressForm.partner_id')
  onPartnerChange(value: string) {
    if (value) {
      this.$store.dispatch('getEventTypes', { organizer: value, limit: 5000 });
      this.progressForm.event_id = null;
    } else {
      this.$store.dispatch('getEventTypes', { organizer: null, limit: 5000 });
      this.progressForm.event_id = null;
    }
  }

  // @Watch('id')
  // setSiteUserKidId(value: string) {
  //   this.progressForm.site_user_kid_id = value;
  // }

  @Watch('mentorFilterValue')
  async onFilterMentorChange(value: string) {
    if (value === '' || value.length < 3) this.mentors = [];
    if (value.length > 2) {
      this.mentorFilterText = 'Подождите, идет поиск...';
      const { data } = await nokoService(this.$api).getMentors(value);
      const response = (data as any)[0];
      switch (response.hint) {
        case 'to_much_data': {
          this.mentorFilterText = 'Уточните критерии поиска';
          break;
        }
        case 'not_found': {
          this.mentorFilterText = 'Ничего не найдено';
          this.mentors = [];
          break;
        }
        default: {
          this.mentorFilterText = '';
          this.mentors = mapItems(response.result);
          break;
        }
      }
    }
  }

  created() {
    const { state } = progressStore;
    const { municipality_id } = this.state.user.profile;
    this.progressForm = {
      ...state,
      municipality: state.municipality || municipality_id,
      student_id: this.id,
    };
  }

  beforeDestroy() {
    store.modal = false;
  }

  destroyed() {
    this.isFormOpen
      ? progressStore.addProgressFormData({ ...this.progressForm })
      : progressStore.cleanProgressState();
  }

  inputMentor(payload: any) {
    this.mentorFilterValue = payload;
    this.mentorFilterText =
      payload.length > 2
        ? 'Уточните критерии поиска'
        : 'Введите как минимум 3 символа';
  }

  inputFile($events: any) {
    const [files] = $events.target.files;
    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
    ].includes(files.type);
    const toLarge = files.size > MaxFileEnum.MAX_FILE;
    if (allowedTypes && !toLarge) {
      this.progressForm.confirmation_file = files;
      this.fileWarnings = '';
    } else {
      this.fileWarnings =
        allowedTypes && toLarge
          ? FileFieldEnum.MAX_VOLUME
          : FileFieldEnum.FILE_FORMAT;
      this.progressForm.confirmation_file = { name: '' };
    }
  }

  submitProgressForm() {
    const { $v, progressForm } = this;
    if ($v) {
      $v.$touch();
      if (!$v.$invalid) {
        this.$emit('submitProgressForm', { ...progressForm });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/forms/resultform/AddResult.vue